module.exports = __webpack_public_path__ + "media/images/recrutare/carousel/carousel_2-04f47e1bdeb567c9936f3b0729ab6f53.jpg";